import PropTypes from 'prop-types';

import React, { Children } from 'react';
import enhanceWithClickOutside from 'react-click-outside';

import StyledPopup from './StyledPopup';

export class Popup extends React.PureComponent {
  componentDidMount() {
    this.setSizes();
  }

  setSizes() {
    if (this.el) {
      this.width = this.el.offsetWidth;
      this.height = this.el.offsetHeight;
      this.parentWidth = this.el.offsetWidth;
      this.parentHeight = this.el.parentElement.offsetHeight;
      this.forceUpdate();
    }
  }

  handleClickOutside = () => {
    if (this.props.onClickOutside) {
      this.props.onClickOutside();
    }
  }

  render() {
    return (
      <StyledPopup
        position={this.props.position}
        ref={(el) => { this.el = el; }}
        width={this.width}
        height={this.height}
        parentWidth={this.parentWidth}
        parentHeight={this.parentHeight}
      >
        {Children.toArray(this.props.children)}
      </StyledPopup>
    );
  }
}

Popup.propTypes = {
  children: PropTypes.node.isRequired,
  position: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  onClickOutside: PropTypes.func,
};

Popup.defaultProps = {
  position: 'top',
};

export default enhanceWithClickOutside(Popup);
